import React, { createContext, useContext, useReducer } from 'react';

const appContext = createContext({
  state: { error: { isOpen: false, message: '' }, isBlocked: false, isCustomAddress: false, showCard: false, iframeKey: 0 },
  dispatch: () => null,
});

const actionTypes = {
  setError: 'SET_ERROR',
  clearError: 'CLEAR_ERROR',
  setBlocked: 'SET_BLOCKED',
  setShowCard: 'SET_SHOW_CARD',
  setAddress: 'SET_ADDRESS',
  setIframeKey: 'SET_IFRAME_KEY',
};

function appReducer(state, action) {
  switch (action.type) {
    case actionTypes.setError: {
      return {
        ...state,
        error: {
          isOpen: true,
          message: action.payload,
        },
      };
    }
    case actionTypes.clearError: {
      return {
        ...state,
        error: {
          isOpen: false,
          message: '',
        },
      };
    }
    case actionTypes.setAddress: {
      return {
        ...state,
        isCustomAddress: action.payload,
      };
    }
    case actionTypes.setBlocked: {
      return {
        ...state,
        isBlocked: action.payload,
      };
    }
    case actionTypes.setShowCard: {
      return {
        ...state,
        showCard: action.payload,
      };
    }
    case actionTypes.setIframeKey: {
      return {
        ...state,
        iframeKey: action.payload,
      };
    }
    default:
      return state;
  }
}

const initialValue = {
  error: '',
};

function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialValue);
  const value = { state, dispatch };

  return <appContext.Provider value={value}>{children}</appContext.Provider>;
}

function useApp() {
  return useContext(appContext);
}

export { useApp, AppProvider, actionTypes };
